/**
 * Clientes recentes que o boot restaura, e quando o cliente do boot NÃO volta.
 *
 * A chave dos recentes é por `id_interno`, e não por `id`: são campos
 * diferentes do mesmo usuário, e trocá-los devolve a lista de outro
 * profissional.
 *
 * Util global, então ele não sabe de módulo de feature: quem tem escopo
 * concorrente com o cliente entrega o fato por argumento.
 */

/**
 * @param {String|Number} idInterno
 * @returns {String} chave dos clientes recentes no localStorage
 */
export const buildRecentClientsKey = (idInterno) => `698dc${idInterno}19d489c`

/**
 * @param {Object} user usuário já montado em `user/currentUser`
 * @returns {Array} clientes recentes persistidos, ou lista vazia
 */
export const readRecentClients = (user = {}) => {
  if (user.IS_CLIENTE) return []
  if (typeof Storage === 'undefined') {
    console.warn(
      'LocalStorage not supported. Search clients history will fail.'
    )
    return []
  }
  if (!globalThis.localStorage) return []

  const bruto = globalThis.localStorage.getItem(
    buildRecentClientsKey(user.id_interno)
  )
  if (!bruto) return []

  try {
    const lista = JSON.parse(bruto)
    return Array.isArray(lista) ? lista : []
  } catch {
    return []
  }
}

/**
 * @param {Object} params
 * @param {String|Number} params.grupoPersistido escopo concorrente já salvo
 * @returns {Boolean} `false` enquanto houver escopo persistido no lugar do cliente
 */
export const shouldRestoreBootClient = ({ grupoPersistido } = {}) =>
  !grupoPersistido
